module.exports = __webpack_public_path__ + "img/UTGOBL-6.932fe209.jpg";